import { useEffect, useState } from "react";
import {
  Button as AntButton,
  Input,
  InputNumber,
  Table,
  Button,
  Modal,
  Tooltip,
} from "antd";
import axios from "apis/axios.global";
import Papa from "papaparse";

import {
  AiOutlinePlusCircle,
  AiOutlineDelete,
  AiOutlineDownCircle,
  AiOutlineCheckCircle,
  AiOutlineRetweet,
} from "react-icons/ai";

import ChecklistInformationModal from "../ChecklistInformationModal";
import { useNavigate, useParams } from "react-router-dom";
import useStyles from "./style";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import { MdExpandMore } from 'react-icons/md';
import DataTypeforTableCells from "../DataTypeforTableCells";
import { v4 as uuidv4 } from "uuid";

type RowFieldType = "label" | "specification" | "value" | "remarks";
interface TableHeader {
  id: string;
  type: string;
  attributeName: string;
  rowFieldType: RowFieldType;
}

const DesignTime = () => {
  const classes = useStyles();
  const { urlId } = useParams<{ urlId: any }>();
  const navigate = useNavigate();
  const { confirm } = Modal;

  const [formData, setFormData] = useState<any>();
  const [newDataSource, setNewDataSource] = useState<any[]>([]);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [selectedValues, setSelectedValues] = useState<any[]>([]);
  const [title, setTitle] = useState();
  const [inputs, setInputs] = useState<any[]>([]);
  const [inputCount, setInputCount] = useState(0);
  const [showModal, setShowModal] = useState<any>({});
  const [finalData, setFinalData] = useState<any[]>([]);
  const [numberofColumnsForTable, setNumberofColumnsForTable] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempColumn, setTempColumn] = useState<any>(null);
  const [tableData, setTableData] = useState<any>();
  const [expanded, setExpanded] = useState(true);
  const [visibleIndices, setVisibleIndices] = useState<any>({});
  const [selectedField, setSelectedField] = useState("");
  const [selectedFormula, setSelectedFormula] = useState("");
  const [selectedFieldToleranceType, setSelectedFieldToleranceType] =
    useState("none");
  const [selectedFieldToleranceValue, setSelectedFieldToleranceValue] =
    useState(0);
  const [newOption, setNewOption] = useState("");
  const [modalClose, setModalClose] = useState(false);
  const [clickedCell, setClickedCell] = useState({
    rowIndex: null,
    value: "",
    index: null,
    columnType: "",
  });
  const [selectedCellDatatypes, setSelectedCellDatatypes] =
    useState<any>(clickedCell);
  const [showCustomMultiValueInput, setShowCustomMultiValueInput] =
    useState(false);

  //----------consoles----------------
  // console.log("visibleIndices", visibleIndices);
  // console.log("selectedId22", selectedId);
  // console.log("formData", formData);
  // console.log("finalData", finalData);
  // console.log("selectedValues66", selectedValues);
  // console.log("inputs", inputs);
  console.log("newDataSource", newDataSource);
  // console.log("selectedId", selectedId);
  // console.log("clickedCell", clickedCell);
  // console.log("isModalOpen", isModalOpen);
  // console.log("visibleIndices", visibleIndices);
  // console.log("tempColumn", tempColumn);
  // console.log("selectedCellDatatypes", selectedCellDatatypes);
  // console.log("selectedField", selectedField);

  //---------useeffects-------------------

  useEffect(() => {
    if (selectedCellDatatypes) {
      const updatedDataSource = newDataSource.map((row, rowIndex) => {
        if (rowIndex === selectedCellDatatypes.rowIndex) {
          const updatedCells = row.cells.map((cell: any, cellIndex: any) => {
            if (
              cell.value === selectedCellDatatypes.value &&
              cellIndex === selectedCellDatatypes.index
            ) {
              return {
                ...cell,
                datatype: selectedCellDatatypes.dataType,
                dataOptions: selectedCellDatatypes.dataOptions,
                toleranceType: selectedCellDatatypes.toleranceType,
                toleranceValue: selectedCellDatatypes.toleranceValue,
              };
            }
            return cell;
          });
          return { ...row, cells: updatedCells };
        }
        return row;
      });
      setNewDataSource(updatedDataSource);
    }
  }, [selectedCellDatatypes]);

  // copy and paste data to the table function
  useEffect(() => {
    const handlePaste = (event: ClipboardEvent) => {
      event.preventDefault();
      const pastedData = event.clipboardData?.getData("Text");

      if (pastedData) {
        Papa.parse(pastedData, {
          complete: (result) => {
            const parsedData = result.data;

            const newData = parsedData.map((row: any, rowIndex: number) => {
              const cells = formData.tableHeader.map(
                (header: any, colIndex: any) => ({
                  id: uuidv4(),
                  tableHeaderId: header.id,
                  columnName: header.attributeName,
                  columnType: header.rowFieldType,
                  value: row[colIndex] || "", // Fallback to an empty string if data is missing
                  datatype: "text",
                  dataOptions: "",
                })
              );

              return {
                row: rowIndex + 1, // Set the row number (1-based index)
                cells,
              };
            });

            // Update your new state here with `newData`
            setNewDataSource((prevDataSource) => [
              ...prevDataSource,
              ...newData,
            ]);
          },
        });
      }
    };

    document.addEventListener("paste", handlePaste);
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, [formData?.tableHeader]);

  // Reset the values whenever clickedCell changes
  useEffect(() => {
    setSelectedCellDatatypes({
      ...clickedCell,
      dataType: selectedField,
      dataOptions: selectedFormula,
      toleranceType: selectedFieldToleranceType,
      toleranceValue: selectedFieldToleranceValue,
    });
    // setSelectedCellDatatypes(clickedCell);
  }, [clickedCell]);

  // storing formId to the state
  useEffect(() => {
    if (urlId) {
      setSelectedId(urlId);
    }
  }, [urlId]);

  //calling table Data from the api
  useEffect(() => {
    if (selectedId) {
      getTableData();
    }
  }, [selectedId]);

  // Update formData when title changes
  useEffect(() => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      title,
    }));
  }, [title]);

  // Update formData when selectedValues change
  useEffect(() => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      formHeader: finalData,
    }));
  }, [finalData]);

  useEffect(() => {
    const mergedData = inputs.map((input, index) => ({
      id: selectedValues[index]?.id ? selectedValues[index]?.id : uuidv4(),
      attributeName: input,
      ...selectedValues[index],
    }));
    setFinalData(mergedData);
  }, [inputs, selectedValues]);

  //---------------functions--------------------

  //-------Form title---------

  const handleChangeTitle = (value: any) => {
    setTitle(value);
  };

  //--------to select number of form headers----------
  const handleSelectChange = (value: any) => {
    setInputCount(value);
    setInputs(Array.from({ length: value }, () => ""));
  };

  //--------to add addtional form headers by cliking plus button----------
  const addInput = () => {
    setInputs([...inputs, ""]);
    setInputCount(inputCount + 1);
  };

  //-------Delete perticular form header -------------
  const deleteInput = (index: any) => {
    const updatedInputs = inputs.filter((_, i) => i !== index);
    setInputs(updatedInputs);
    setInputCount(inputCount - 1);
    const newSelectedValues = selectedValues.filter((_, i) => i !== index);
    setSelectedValues(newSelectedValues);
  };

  //-------to store form header input value---------------
  const handleInputChange = (index: any, value: any) => {
    const updatedInputs = [...inputs];
    updatedInputs[index] = value;
    setInputs(updatedInputs);
  };

  //----------to toggle the data type componenet show or hide -----------
  const toggleModal = (index: any) => {
    setShowModal((prevState: any) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  //-----------to add new row to the table------------------
  const addRow = () => {
    const newRowNumber = newDataSource.length + 1;
    // Create a new row object
    const newRows = {
      row: newRowNumber,
      cells: formData.tableHeader.map((attr: any) => ({
        id: uuidv4(),
        tableHeaderId: attr.id,
        columnName: attr.attributeName,
        columnType: attr.rowFieldType,
        value: "", // Initial empty value for each cell
        datatype: "text", // Add datatype if necessary
        dataOptions: "", // Add dataOptions if necessary
      })),
    };

    setNewDataSource((prev) => [...prev, newRows]);
  };

  //------to add new column for table -----------
  const addColumnsForTable = () => {
    const newColumn = {
      id: uuidv4(), // Unique ID
      type: "",
      attributeName: "", // Initially empty to allow user input
      rowFieldType: "label", // Initial row field type
    };

    if (formData.tableHeader) {
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        tableHeader: [...prevFormData.tableHeader, newColumn],
      }));

      setTempColumn(newColumn);
    } else {
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        tableHeader: [newColumn],
      }));
      setTempColumn(newColumn);
    }

    setNumberofColumnsForTable((prev) => prev + 1);
  };

  //------to save new column for table -----------
  const saveColumnName = (index: any, newAttributeName: any) => {
    setFormData((prevFormData: any) => {
      const updatedTableHeader = prevFormData.tableHeader.map(
        (column: any, idx: any) =>
          idx === index
            ? { ...column, attributeName: newAttributeName }
            : column
      );

      const updatedDataSource = newDataSource.map((row) => {
        const existingCells = row.cells.map((cell: any) => {
          const header = updatedTableHeader.find(
            (header: any) => header.attributeName === cell.columnName
          );
          return {
            ...cell,
            columnType: header?.rowFieldType || cell.columnType,
          };
        });

        const newCells = updatedTableHeader
          .filter(
            (header: any) =>
              !existingCells.some(
                (cell: any) => cell.columnName === header.attributeName
              )
          )
          .map((header: any) => ({
            id: uuidv4(),
            tableHeaderId: header.id,
            columnName: header.attributeName,
            columnType: header.rowFieldType,
            value: "",
            datatype: "text",
            dataOptions: "",
          }));

        return {
          ...row,
          cells: [...existingCells, ...newCells],
        };
      });

      setNewDataSource(updatedDataSource);

      return {
        ...prevFormData,
        tableHeader: updatedTableHeader,
      };
    });

    setTempColumn(null); // Clear the temporary column
  };

  const updateTableHeader = (numColumns: any) => {
    const newTableHeader = Array.from({ length: numColumns }, (_, index) => ({
      id: uuidv4(),
      type: "",
      attributeName: "",
      rowFieldType: "label",
    }));
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      tableHeader: newTableHeader,
    }));
  };

  const handleSelectForTableColumns = (value: any) => {
    setNumberofColumnsForTable(value);
    updateTableHeader(value);
  };

  //--------final submit of data-----------
  const submitData = async () => {
    const finalFormData = {
      ...formData,
      tableContent: newDataSource,
    };
    const response = await axios.post(
      `/api/auditchecksheet/createAuditChecksheetTemplate`,
      finalFormData
    );
    navigate("/checksheet");
  };

  //--------update Data-----------------
  const updateData = async () => {
    const finalFormData = {
      ...formData,
      tableContent: newDataSource,
    };
    const response = await axios.patch(
      `/api/auditchecksheet/updateAuditChecksheetTemplate/${selectedId}`,
      finalFormData
    );
    navigate("/checksheet");
  };

  //----------to target and store the table cell value -------------
  const handleInputChangeValue = (
    rowIndex: any,
    columnName: any,
    newValue: any
  ) => {
    setNewDataSource((prevDataSource) => {
      const updatedDataSource = [...prevDataSource];
      // Locate the specific cell to update
      const cell = updatedDataSource[rowIndex].cells.find(
        (c: any) => c.columnName === columnName
      );
      if (cell) {
        if (
          cell.columnType === "specification" &&
          cell.datatype === "numberRange"
        ) {
          if (newValue?.min) {
            cell.minValue = newValue.min;
          }
          if (newValue?.max) {
            cell.maxValue = newValue.max;
          }
        } else {
          cell.value = newValue; // Update the cell value
        }
      }
      return updatedDataSource;
    });
  };

  //--------to get table Data from the api ------------
  const getTableData = async () => {
    const result = await axios.get(
      `/api/auditchecksheet/getAuditChecksheetTemplateById/${selectedId}`
    );

    const data = result.data;

    // Extract and set the formHeader data to selectedValues
    const extractedValues = data.formHeader.map((item: any) => ({
      id: item?.id,
      datatype: item.datatype,
      dataOptions: item.dataOptions,
    }));

    setSelectedValues(extractedValues);

    setTableData(data);

    // setFormData(result.data.tableHeader);
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      tableHeader: data?.tableHeader,
      formHeaderTitle: data?.formHeaderTitle,
      tableHeaderTitle: data?.tableHeaderTitle,
    }));

    setTitle(data?.title);

    setNewDataSource(data?.tableContent);
    const formHeaderLabels =
      data?.formHeader?.map((item: any) => item.attributeName) || [];

    setInputs(formHeaderLabels);
    setNumberofColumnsForTable(data?.tableHeader?.length);
    setInputCount(data?.formHeader?.length);

    const tableHeaderData: TableHeader[] = data?.tableHeader ?? [];

    const rowFieldTypeMap: Record<RowFieldType, number> = {
      label: 1,
      specification: 2,
      value: 3,
      remarks: 4,
    };

    // Creating the result object
    const mappedData = tableHeaderData.reduce(
      (acc: Record<number, number>, item, index) => {
        acc[index] = rowFieldTypeMap[item.rowFieldType];
        return acc;
      },
      {}
    );
    setVisibleIndices(mappedData);
  };

  //------ table header type selection function (label,specialation,value)-------
  const updateRowFieldType = (value: string, index: number) => {
    const updatedTableHeader = [...formData.tableHeader];
    updatedTableHeader[index].rowFieldType = value;
    setFormData({
      ...formData,
      tableHeader: updatedTableHeader,
    });
  };

  // modal functions

  const showModal2 = (
    rowIndex: any,
    value: any,
    index: any,
    columnType: any
  ) => {
    // Find the row based on rowIndex
    const row = newDataSource.find((rowData) => rowData.row === rowIndex + 1);

    if (row) {
      // Find the cell based on index and value
      const cell = row.cells.find(
        (cellData: any, cellIndex: any) =>
          cellIndex === index && cellData.value === value
      );

      if (cell) {
        setClickedCell({
          rowIndex,
          value,
          index,
          columnType,
        });
        setIsModalOpen(true);
        setSelectedField(cell?.datatype);
        setSelectedFormula(cell?.dataOptions);
        setSelectedFieldToleranceType(cell?.toleranceType);
        setSelectedFieldToleranceValue(cell?.toleranceValue);
        setSelectedCellDatatypes({
          rowIndex,
          value,
          index,
          dataType: cell.datatype,
          dataOptions: cell.dataOptions,
          toleranceType: cell.toleranceType,
          toleranceValue: cell.toleranceValue,
        }); // Set selectedCellDatatypes with the found values
        setModalClose(false);
      }
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setModalClose(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Form header accordian open and close function
  const handleAccordionChange = () => {
    setExpanded(!expanded);
  };

  const handleChangeFormHeaderTitle = (e: any) => {
    setFormData({
      ...formData,
      formHeaderTitle: e,
    });
  };

  const handleChangeTableHeaderTitle = (e: any) => {
    setFormData({
      ...formData,
      tableHeaderTitle: e,
    });
  };

  const handleNext = (index: number) => {
    setVisibleIndices((prevIndices: any) => {
      const currentIndex = prevIndices[index] ?? 0; // Use 0 if undefined
      const newIndex = (currentIndex % 4) + 1; // Cycle through 1, 2, 3
      updateRowFieldType(indexToValue(newIndex), index);
      return {
        ...prevIndices,
        [index]: newIndex,
      };
    });
  };

  // Function to map index to corresponding value
  const indexToValue = (index: number) => {
    switch (index) {
      case 1:
        return "label";
      case 2:
        return "specification";
      case 3:
        return "value";
      case 4:
        return "remarks";
      default:
        return "label";
    }
  };

  // prompt function for form delete
  const showDeleteConfirm = (index: any) => {
    confirm({
      title: "Are you sure you want to delete?",
      // content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteInput(index);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  // Function to render the visible text based on index for table column type
  const renderVisibleText = (index: number) => {
    const texts = ["L", "L", "S", "V", "R"];
    const visibleIndex = visibleIndices[index] ?? 0; // Use 0 if undefined
    return (
      <Tooltip
        title={
          texts[visibleIndex] === "L"
            ? "Label"
            : texts[visibleIndex] === "S"
            ? "Specification"
            : texts[visibleIndex] === "V"
            ? "Value"
            : texts[visibleIndex] === "R"
            ? "Remarks"
            : "Label"
        }
      >
        <p
          style={{
            width: "25px",
            height: "25px",
            border: "2px solid black",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "12px",
            backgroundColor: "#a7f1a7",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {texts[visibleIndex]}
        </p>
      </Tooltip>
    );
  };

  // promt function for table column delete
  const showDeleteColumnConfirm = (index: any) => {
    confirm({
      title: "Are you sure you want to delete this column?",
      // content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteColumn(index);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  // delete function for the table column
  const deleteColumn = (index: any) => {
    const columnToDelete = formData.tableHeader[index].attributeName;
    setFormData((prevFormData: any) => {
      const newTableHeader = [...prevFormData.tableHeader];
      newTableHeader.splice(index, 1);

      return {
        ...prevFormData,
        tableHeader: newTableHeader,
      };
    });
    setNumberofColumnsForTable((prev) => prev - 1);

    const updatedDataSource = newDataSource.map((row) => ({
      ...row,
      cells: row.cells.filter(
        (cell: any) => cell.columnName !== columnToDelete
      ),
    }));
    setNewDataSource(updatedDataSource);
  };

  // Utility function to capitalize the first letter of each word
  const capitalizeFirstLetter = (str: any) => {
    if (Array.isArray(str)) {
      return "Multi Value Options";
    } else {
      return str.replace(/\b\w/g, (char: any) => char.toUpperCase());
    }
  };

  const columns = formData?.tableHeader?.map((attr: any, index: any) => ({
    title: () => (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Input
            type="text"
            value={
              tempColumn && tempColumn.id === attr.id
                ? tempColumn.attributeName
                : attr.attributeName
            }
            onChange={(e) => {
              e.preventDefault();
              if (tempColumn && tempColumn.id === attr.id) {
                setTempColumn({ ...tempColumn, attributeName: e.target.value });
              } else {
                setTempColumn({ id: attr.id, attributeName: e.target.value });
              }
            }}
            placeholder="Enter column name"
            style={{ marginRight: "8px", width: "80%" }}
          />

          <span style={{ display: "flex", gap: "5px", alignItems: "center" }}>
            {renderVisibleText(index)}
            <Tooltip title="Select Column Field Type">
              <AiOutlineRetweet
                onClick={() => handleNext(index)}
                style={{ fontSize: "20px" }}
              />
            </Tooltip>
          </span>
          <AiOutlineDelete
            onClick={() => showDeleteColumnConfirm(index)}
            style={{
              cursor: "pointer",
              color: "black",
              marginLeft: "5px",
              fontSize: "16px",
            }}
          />
          {tempColumn && tempColumn.id === attr.id && (
            <Button
              onClick={() => saveColumnName(index, tempColumn.attributeName)}
              icon={<AiOutlineCheckCircle />}
              style={{ marginLeft: "5px" }}
            ></Button>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          ></div>
        </div>
      </>
    ),
    dataIndex: attr.attributeName.toLowerCase().replace(/\s+/g, "_"),
    render: (text: any, record: any, rowIndex: any) => {
      const columnName = attr.attributeName;
      const cell = record.cells.find((c: any) => c.columnName === columnName);
      const hasDataType = cell && cell.datatype;

      return (
        <div style={{ display: "flex", gap: "10px" }}>
          {cell &&
          cell.columnType === "specification" &&
          cell.datatype === "numberRange" ? (
            <>
              <Input
                type="number"
                value={cell?.minValue || ""}
                placeholder="Min"
                onChange={(e) =>
                  handleInputChangeValue(rowIndex, columnName, {
                    min: parseFloat(e.target.value) || "",
                  })
                }
              />
              _
              <Input
                type="number"
                value={cell?.maxValue || ""}
                placeholder="Max"
                onChange={(e) =>
                  handleInputChangeValue(rowIndex, columnName, {
                    max: parseFloat(e.target.value) || "",
                  })
                }
                suffix={
                  cell &&
                  (cell.columnType === "specification" ||
                    cell.columnType === "label" ||
                    cell.columnType === "remarks" ||
                    cell.columnType === "None") && (
                    <Tooltip
                      placement="top"
                      title={
                        <div>
                          {cell.datatype ? (
                            <>
                              <p>Datatype: {cell.datatype || ""}</p>
                              <p>Data Options: {cell.dataOptions || ""}</p>
                            </>
                          ) : (
                            <p>Data Type is not assigned Yet</p>
                          )}
                        </div>
                      }
                      color="#669999"
                    >
                      <AiOutlineDownCircle
                        onClick={() =>
                          showModal2(
                            rowIndex,
                            cell.value,
                            index,
                            cell.columnType
                          )
                        }
                      />
                    </Tooltip>
                  )
                }
              />
              {cell && cell.datatype === "numberRange" && (
                <span style={{ fontSize: "14px" }}>{cell.dataOptions}</span>
              )}
            </>
          ) : (
            <>
              <Input
                type={
                  cell &&
                  cell.columnType === "specification" &&
                  cell.datatype === "number"
                    ? "number"
                    : "text"
                }
                value={cell ? cell.value : ""}
                onChange={(e) =>
                  handleInputChangeValue(
                    rowIndex,
                    columnName,
                    cell && cell.datatype === "number"
                      ? parseFloat(e.target.value) || ""
                      : e.target.value
                  )
                }
                suffix={
                  <>
                    {cell && (
                      <>
                        {(cell.columnType === "specification" ||
                          cell.columnType === "label" ||
                          cell.columnType === "remarks" ||
                          cell.columnType === "None") && (
                          <Tooltip
                            placement="top"
                            title={
                              <div>
                                {cell.datatype ? (
                                  <>
                                    <p>Datatype: {cell.datatype}</p>
                                    <p>Data Options: {cell.dataOptions || "N/A"}</p>
                                  </>
                                ) : (
                                  <p>Data Type is not assigned yet</p>
                                )}
                              </div>
                            }
                            color="#669999"
                          >
                            <AiOutlineDownCircle
                              onClick={() =>
                                showModal2(rowIndex, cell.value, index, cell.columnType)
                              }
                            />
                          </Tooltip>
                        )}
                
                        {cell.datatype === "number" && (
                          <span style={{ fontSize: "14px" }}>
                            {cell.dataOptions}{" "}
                            {cell.toleranceType === "tolerance" &&
                              cell.toleranceValue &&
                              `(-${cell.toleranceValue.min}/+${cell.toleranceValue.max})`}
                          </span>
                        )}
                      </>
                    )}
                  </>
                }
                
              />
              {/* {cell && cell.datatype === "number" && (
                <span style={{ fontSize: "14px" }}>
                  {cell.dataOptions}{" "}
                  {cell.toleranceType === "tolerance" &&
                    `( +${cell?.toleranceValue?.max}, -${cell?.toleranceValue?.min} )`}
                </span>
              )} */}
            </>
          )}
        </div>
      );
    },
  }));

  const handleAddRow = (index: number) => {
    const newRowNumber = newDataSource.length + 1;
    const newRow = {
      row: newRowNumber,
      cells: formData.tableHeader.map((attr: any) => ({
        id: uuidv4(),
        tableHeaderId: attr.id,
        columnName: attr.attributeName,
        columnType: attr.rowFieldType,
        value: "", // Initial empty value for each cell
        datatype: "text", // Add datatype if necessary
        dataOptions: "", // Add dataOptions if necessary
      })),
    };

    setNewDataSource((prev) => {
      const updatedData = [...prev];
      updatedData.splice(index + 1, 0, newRow); // Insert the new row below the current index
      return updatedData;
    });
  };

  const handleDeleteRow = (index: number) => {
    setNewDataSource((prev) =>
      prev.filter((_, rowIndex) => rowIndex !== index)
    );
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "20px",
        }}
      >
        <div></div>
        <div>
          <label
            style={{
              fontSize: "18px",
              color: "#003059",
              fontWeight: "bold",
            }}
          >
            Checksheet Title :{" "}
          </label>
          <Input
            placeholder="Checksheet Title"
            style={{ width: 200, marginLeft: "15px" }}
            onChange={(e) => handleChangeTitle(e.target.value)}
            value={title}
          />
        </div>
        <div>
          {selectedId ? (
            <AntButton
              type="primary"
              onClick={updateData}
              style={{
                backgroundColor: "#003059",
                color: "white",
              }}
            >
              Update
            </AntButton>
          ) : (
            <AntButton
              type="primary"
              onClick={submitData}
              style={{
                backgroundColor: "#003059",
                color: "white",
              }}
            >
              Submit
            </AntButton>
          )}
          <Button
            onClick={() => {
              navigate("/checksheet");
            }}
            style={{
              backgroundColor: "#003059",
              color: "white",
              marginLeft: "5px",
            }}
          >
            Back
          </Button>
        </div>
      </div>
      <Accordion
        style={{ marginTop: "20px" }}
        className={classes.headingRoot}
        expanded={expanded}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          expandIcon={<MdExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.summaryRoot}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Input
              placeholder="Form Header Title"
              style={{ width: 200, marginLeft: "15px" }}
              onChange={(e) => handleChangeFormHeaderTitle(e.target.value)}
              value={formData?.formHeaderTitle}
            />
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.headingRoot}>
          <div style={{ padding: "20px" , }}>
            <div style={{display:"flex", gap:"20px", alignItems:"center"}}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <label
                style={{
                  color: "#003059",
                  fontWeight: "bold",
                }}
              >
                Select Layout for {formData?.formHeaderTitle} :{" "}
              </label>
              <InputNumber
                min={0}
                max={100}
                value={inputCount}
                onChange={handleSelectChange}
                style={{ width: 100, marginLeft: "10px", color: "black" }}
                placeholder="Enter a number"
                disabled={urlId}
              />
              <Tooltip title="Add New Column">
                <Button
                  onClick={addInput}
                  style={{ marginLeft: 10, cursor: "pointer" }}
                  icon={<AiOutlinePlusCircle />}
                ></Button>
              </Tooltip>
            </div>
            </div>
            <div style={{ display: "flex", gap: "15px", flexWrap:"wrap", alignItems:"center" }}>
              {inputs.map((input, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    marginBottom: 10,
                    flexDirection: "column",
                  }}
                >
                  <div>
                    <Input
                      placeholder={`Column ${index + 1}`}
                      value={input}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      style={{ width: 200, marginRight: 10 }}
                      suffix={
                        <Tooltip
                          title={
                            finalData[index]?.datatype ? (
                              <>
                                <p>{`Data Type : ${capitalizeFirstLetter(
                                  finalData[index]?.datatype || "N/A"
                                )}`}</p>
                                <p>{`Data Objects : ${capitalizeFirstLetter(
                                  finalData[index]?.dataOptions || "N/A"
                                )}`}</p>
                              </>
                            ) : (
                              <>
                                <p>Data Type Is Not Assigned Yet</p>
                              </>
                            )
                          }
                          color="#669999"
                        >
                          <AiOutlineDownCircle onClick={() => toggleModal(index)} />
                        </Tooltip>
                      }
                    />

                    <AiOutlineDelete
                      onClick={() => showDeleteConfirm(index)}
                      style={{ cursor: "pointer", color: "black" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                    }}
                  >
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "start",
                      }}
                    >
                      {showModal[index] && (
                        <ChecklistInformationModal
                          setSelectedValues={setSelectedValues}
                          selectedValues={selectedValues}
                          index={index}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<MdExpandMore />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          className={classes.summaryRoot}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Input
              placeholder="Table Header Title"
              style={{ width: 200, marginLeft: "15px" }}
              onChange={(e) => handleChangeTableHeaderTitle(e.target.value)}
              value={formData?.tableHeaderTitle}
            />
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ width: "100%", display: "flex" }}>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    color: "#003059",
                    fontWeight: "bold",
                  }}
                >
                  Select Layout for {formData?.tableHeaderTitle} :{" "}
                </label>
                <InputNumber
                  min={0}
                  max={100}
                  value={numberofColumnsForTable}
                  onChange={handleSelectForTableColumns}
                  style={{
                    width: 100,

                    marginLeft: "10px",
                    color: "black",
                  }}
                  placeholder="Enter a number"
                  disabled={urlId}
                />
                <Tooltip title="Add New Column">
                  <Button
                    onClick={addColumnsForTable}
                    style={{ marginLeft: 10, cursor: "pointer" }}
                    icon={<AiOutlinePlusCircle />}
                  ></Button>
                </Tooltip>
              </div>

              <div className={classes.tableContainer}>
                <Table
                  dataSource={newDataSource}
                  columns={
                    !columns?.length
                      ? columns
                      : [
                          ...columns,
                          {
                            title: "Actions",
                            key: "actions",
                            render: (_: any, record: any, index: number) => (
                              <div style={{ display: "flex", gap: "10px" }}>
                                <Tooltip title="Delete Row">
                                  <Button
                                    onClick={() => handleDeleteRow(index)}
                                    style={{
                                      marginLeft: 10,
                                      cursor: "pointer",
                                    }}
                                    icon={<AiOutlineDelete />}
                                  ></Button>
                                </Tooltip>
                                <Tooltip title="Add Row Below">
                                  <Button
                                    onClick={() => handleAddRow(index)}
                                    style={{
                                      marginLeft: 10,
                                      cursor: "pointer",
                                    }}
                                    icon={<AiOutlinePlusCircle />}
                                  ></Button>
                                </Tooltip>
                              </div>
                            ),
                          },
                        ]
                  }
                  pagination={false}
                  bordered
                  onRow={() => ({
                    onMouseEnter: (e) => {
                      const icon = e.currentTarget.querySelector(".info-icon");
                      if (icon) icon.style.visibility = "visible";
                    },
                    onMouseLeave: (e) => {
                      const icon = e.currentTarget.querySelector(".info-icon");
                      if (icon) icon.style.visibility = "hidden";
                    },
                  })}
                />
              </div>

              {formData?.tableHeader?.length > 0 ? (
                <div
                  style={{ display: "flex", gap: "20px", marginTop: "16px" }}
                >
                  <AntButton onClick={addRow} type="primary" style={{}}>
                    Add Row
                  </AntButton>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Modal
        title="Basic Modal"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={isModalOpen}
        closable={false}
        footer={[
          <Button key="ok" type="primary" onClick={handleOk}>
            OK
          </Button>,
        ]}
      >
        <DataTypeforTableCells
          clickedCell={clickedCell}
          selectedCellDatatypes={selectedCellDatatypes}
          setSelectedCellDatatypes={setSelectedCellDatatypes}
          modalClose={modalClose}
          selectedField={selectedField}
          setSelectedField={setSelectedField}
          selectedFormula={selectedFormula}
          setSelectedFormula={setSelectedFormula}
          selectedFieldToleranceType={selectedFieldToleranceType}
          setSelectedFieldToleranceType={setSelectedFieldToleranceType}
          selectedFieldToleranceValue={selectedFieldToleranceValue}
          setSelectedFieldToleranceValue={setSelectedFieldToleranceValue}
          showCustomMultiValueInput={showCustomMultiValueInput}
          setShowCustomMultiValueInput={setShowCustomMultiValueInput}
          newOption={newOption}
          setNewOption={setNewOption}
        />
      </Modal>
      ;
    </>
  );
};

export default DesignTime;
